var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.total > 10
    ? _c("Page", {
        attrs: {
          current: _vm.pageNumber,
          total: _vm.total,
          "page-size": _vm.pageSize,
          "page-size-opts": [10, 20, 50],
          size: "small",
          "show-total": "",
          "show-elevator": "",
          "show-sizer": ""
        },
        on: {
          "on-change": _vm.changePage,
          "on-page-size-change": _vm.changePageSize
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }